import styled from 'styled-components';
// eslint-disable-next-line import/named
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '../styles';

export const ImageEditorContainer = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: rgba(0, 0, 0, 0.8);
    left: 0px;
    top: 0px;
    visibility: ${(props) => (props.imageEditorVisible ? 'visible' : 'hidden')};
`;

export const ImageEditorDiv = styled.div`
    width: 900px;
    height: 500px;
    left: calc(50% - 475px);
    top: 5%;
    position: relative;
`;

export const ButtonDiv = styled.i`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
`;

export const ImageSettingRow = styled(Row)`
    top: 100px;
`;

export const LinkTipDiv = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    padding-right: 4px;
`;

export const Icon = styled(FontAwesomeIcon)`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.primary300};
    margin: 0 4px 0 4px;
    margin-bottom: 2px;
    vertical-align: middle;
`;

export const Link = styled.a`
    font-size: 11px;
    line-height: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.primary300};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.primary700};
    }
`;
